import AdminMarkers from "./AdminMarkers.vue";

export default AdminMarkers;
